import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge33 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権売却時の消費税・仕訳（法人・個人別）' fontWeight={700} />
                <p>
                    ゴルフ会員権にまつわる消費税の基本的な考え方は
                    <a href='/knowledge/7'>ゴルフ会員権の消費税に関して</a>
                    ですでにご紹介していますが、実際に売却する場面では「法人と個人で扱いが違うのか」「仕訳はどう書けばよいのか」といった具体的な疑問が出てきます。
                    <br />
                    本記事では、売却時の消費税の課否判定と、法人・個人それぞれのケースでの仕訳の考え方を具体的に解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の売却は原則として課税取引' fontWeight={700} />
                <p>
                    ゴルフ会員権は経済的な性質としては有価証券に近いものですが、消費税法上は非課税となる有価証券等から明示的に除外されています（消費税法施行令9条2項）。
                    <br />
                    そのため、株式形態・預託金形態のいずれであっても、事業として行うゴルフ会員権の売却は消費税の課税取引に該当し、売却代金（および売却に伴う名義書換料や仲介手数料）が課税対象になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='法人が売却する場合の消費税' fontWeight={700} />
                <p>
                    法人が行う資産の譲渡は、原則としてすべて「事業として」行われたものとみなされます。したがって法人がゴルフ会員権を売却する場合、売却益が出ているか売却損が出ているかにかかわらず、売却代金の全額を課税売上として計上する必要があります。
                    <br />
                    売却によって帳簿価額を下回る金額でしか売れず会計上は損失が生じる場合でも、消費税の計算上は「売却代金＝課税売上高」であることに変わりはないため、申告時に売上計上を漏らさないよう注意しましょう。
                </p>

                <Heading3 title='法人の仕訳例（税抜経理方式）' />
                <p>
                    帳簿価額300万円のゴルフ会員権を、消費税込み330万円（うち消費税30万円）で売却した場合の仕訳イメージは以下のとおりです。
                    <br />
                    <br />
                    （借方）現金預金 330万円
                    <br />
                    （貸方）ゴルフ会員権 300万円
                    <br />
                    （貸方）固定資産売却益 0円
                    <br />
                    （貸方）仮受消費税等 30万円
                    <br />
                    <br />
                    売却価格（税抜）が帳簿価額を下回る場合は「固定資産売却損」を借方に、上回る場合は「固定資産売却益」を貸方に計上して差額を調整します。税込経理方式を採用している場合は、消費税を分離せず売却代金全体を売却損益に含めて処理します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='個人が売却する場合の消費税' fontWeight={700} />
                <p>
                    個人がゴルフ会員権を売却する場合は、その個人が「事業として」行っているかどうかで扱いが変わります。
                </p>

                <Heading3 title='生活用資産として保有していた場合：消費税は課税対象外' />
                <p>
                    給与所得者などが趣味・福利厚生目的で保有していたゴルフ会員権を単発的に売却する場合は、反復・継続して事業として行う取引にあたらないため、消費税の課税対象にはなりません（不課税取引）。この場合、売却によって利益が出ても、それは所得税における譲渡所得の対象にはなりますが、消費税を意識する必要はありません。
                </p>

                <Heading3 title='会員権業者や個人事業主が事業用資産として保有していた場合：課税対象' />
                <p>
                    会員権販売業者が棚卸資産として保有するゴルフ会員権や、個人事業主が事業の用に供していたゴルフ会員権を売却する場合は、事業として行う資産の譲渡にあたるため課税対象です。基準期間の課税売上高が1,000万円を超えるなどして課税事業者に該当する場合は、消費税の申告・納税義務が生じます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='免税事業者・簡易課税を選択している場合の注意点' fontWeight={700} />
                <p>
                    基準期間の課税売上高が1,000万円以下などの理由で免税事業者に該当する場合は、そもそも消費税の申告義務がないため、ゴルフ会員権の売却についても納税は発生しません。
                    <br />
                    簡易課税制度を選択している事業者の場合、ゴルフ会員権の売却は業種区分（一般的には第四種事業に区分されることが多いとされています）に応じたみなし仕入率で仕入税額控除相当額を計算するため、原則課税とは計算方法が異なります。区分に迷う場合は顧問税理士に確認しましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の売却は、法人であれば売却損益にかかわらず全額を課税売上として計上する必要があり、個人であれば生活用資産か事業用資産かによって課税・不課税が分かれます。
                    <br />
                    年会費や名義書換料など、その他の費用の勘定科目については
                    <a href='/knowledge/32'>年会費の勘定科目・経費算入の可否</a>
                    でも解説していますので、あわせてご確認ください。
                    <br />
                    仕訳や申告方法に不安がある場合は、顧問税理士に相談のうえで進めることをおすすめします。ゴルフ会員権の売却自体は、住地ゴルフまでお気軽にご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge33;
